// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea3344ee","239":"e7bd9609","453":"e297872a","455":"f1af5d6c"}[chunkId] + ".chunk.js";
};